export enum ConfigurableSections {
  nav = 'nav',
  search = 'search',
  projects = 'projects',
  myProjects = 'myProjects',
  newProject = 'newProject',
  notifications = 'notifications',
  pricing = 'pricing',
}
